import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "variant"],
  _excluded2 = ["children", "disabled", "variant"];
import AIButton from 'ai-components-ui-library/components/buttons/AIButton';
import { BreezeIcon } from '../Icons/BreezeIcon';
import { ButtonContent } from './ButtonContent';
import { BorderButton } from './BorderButton';
import { BreezeLogo } from '../Icons/BreezeLogo';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const USAGE_TRACKER = 'WE HAVE CUSTOM TRACKING IN PLACE AND AI-EXTENSIBILITY TEAM IS AWARE';
export const ButtonBreeze = _ref => {
  let {
      children,
      variant = 'primary'
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  if (variant === 'breeze-border') {
    return /*#__PURE__*/_jsx(BorderButton, Object.assign({}, rest, {
      children: children
    }));
  }
  return /*#__PURE__*/_jsx(AIButton, Object.assign({}, rest, {
    showBreezeIcon: false,
    usageTracker: USAGE_TRACKER,
    use: variant,
    children: /*#__PURE__*/_jsx(ButtonContent, {
      children: children
    })
  }));
};
export const ButtonIconBreeze = _ref2 => {
  let {
      children,
      disabled,
      variant
    } = _ref2,
    rest = _objectWithoutPropertiesLoose(_ref2, _excluded2);
  return /*#__PURE__*/_jsxs(ButtonBreeze, Object.assign({}, rest, {
    disabled: disabled,
    variant: variant,
    children: [variant === 'breeze-border' ? /*#__PURE__*/_jsx(BreezeLogo, {
      inlineSize: "1em",
      insetBlockStart: "space-3xs",
      opacity: disabled ? 0.5 : 1,
      position: "relative"
    }) : /*#__PURE__*/_jsx(BreezeIcon, {
      variant: "default"
    }), children]
  }));
};